import { render, staticRenderFns } from "./terminos-condiciones.vue?vue&type=template&id=1cf54572&scoped=true"
import script from "./terminos-condiciones.vue?vue&type=script&lang=js"
export * from "./terminos-condiciones.vue?vue&type=script&lang=js"
import style0 from "./terminos-condiciones.vue?vue&type=style&index=0&id=1cf54572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf54572",
  null
  
)

export default component.exports